// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35d31248","455":"abde836d","977":"bcc665ac"}[chunkId] + ".chunk.js";
};